// extracted by mini-css-extract-plugin
module.exports = {"marginBottom":"ProductAttributesTab_marginBottom__31fMi"};